import ChartIcon from '../Assets/Images/Chart.js_logo.svg.png';
import Gitcon from '../Assets/Images/Git.png';
import ChatGPT from '../Assets/Images/icons/ChatGPT.png';
import figmaIcon from '../Assets/Images/icons/figma.svg';
import nodeIcon from '../Assets/Images/icons/node.svg';
import photoshopIcon from '../Assets/Images/icons/photoshop.svg';
import xdIcon from '../Assets/Images/icons/xd.svg';
import RBIcon from '../Assets/Images/ReactBootstrapImg.png';
import RenderIcon from '../Assets/Images/renderco_logo.jpg';
import StripeIcon from '../Assets/Images/stripe_logo_icon_167962.png';
import Swegger from '../Assets/Images/swegger.png';

const Skill_left_API = [
    {
        icon: `${StripeIcon}`,
        iconName: 'Stripe',
    },
    {
        icon: `${xdIcon}`,
        iconName: 'XD',
    },
    {
        icon: `${Gitcon}`,
        iconName: 'Git',
    },
    {
        icon: `${Swegger}`,
        iconName: 'Swagger',
    },
    {
        icon: `${nodeIcon}`,
        iconName: 'Node',
    },
    
    {
        icon: `${photoshopIcon}`,
        iconName: 'Photoshop',
    },
    {
        icon: `${RenderIcon}`,
        iconName: 'Render',
    },
    {
        icon: `${RBIcon}`,
        iconName: 'React Bootstrap',
    },
    
    {
        icon: `${ChartIcon}`,
        iconName: 'Chart Js',
    },
    // {
    //     icon: `${illustratorIcon}`,
    //     iconName: 'Illustrator',
    // },
    {
        icon: `${ChatGPT}`,
        iconName: 'ChatGPT',
    },
    {
        icon: `${figmaIcon}`,
        iconName: 'Figma',
    },
    // {
    //     icon: `${wordpressIcon}`,
    //     iconName: 'Wordpress',
    // },     
]
export default Skill_left_API;